module.exports = __webpack_public_path__ + "static/media/0520-r-l.5360fa83.png";